export default "__VITE_ASSET__BBeMEfpR__"